import axios from 'axios'

let baseUrl = process.env.NODE_ENV === 'production' ? 'https://fulfillment.printbelle.com/prod_api' : '/dev_api'
const index = axios.create({
  baseURL: baseUrl, // 设置基本URL
  timeout: 10000, // 设置请求超时时间
})

// 添加请求拦截器
index.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 可以在这里添加请求头、处理请求参数等
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
index.interceptors.response.use(
  response => {
    // 对响应数据做些什么
    // 可以在这里处理返回的数据、统一错误处理等
    return response.data
  },
  error => {
    // 对响应错误做些什么
    return Promise.reject(error)
  }
)

export const request = (config) => {
  return index(config)
}

export const get = (url, params, token) => {
  const headers = {}
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }
  return request({method: 'GET', url, params, headers})
}

export const post = (url, data) => {
  return request({method: 'POST', url, data})
}

/**
 * 获取前端限制配置
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getWebLimitConfig () {
  return get('/index/web/limit')
}



// WEBPACK FOOTER //
// ./src/api/index.js